import { Link, useParams } from "react-router-dom";

const getName = (slug) => {
  switch (slug) {
    case "case-studies":
      return "Case studies";
    case "blog":
      return "Blog";
    case "solutions":
      return "Solutions";
    case "platform":
      return "Platform";
  }
};

export const Breadcrumb = ({ currentName }) => {
  const params = useParams();
  const crumbs = params?.["*"] ? params?.["*"].split("/") : [];

  if (crumbs.length <= 1) {
    return null;
  }

  return (
    <p className="breadcrumbs">
      <Link to={"/"}>Home</Link>
      {crumbs.map((link, index) => {
        if (crumbs.length - 1 === index && currentName) {
          return ` / ${currentName}`;
        }

        return (
          <>
            {" / "}
            <Link to={`/${link}`} key={index}>
              {getName(link)}
            </Link>
          </>
        );
      })}
    </p>
  );
};
